// @ts-check
import React from 'react';
import escapeRegExp from 'lodash/escapeRegExp';

/**
 * Add bold to matching target in text.
 *
 * This can be made into component in React 16 with its array support.
 *
 * @param {string} text
 * @param {string} target
 * @returns {import('react').ReactNode}
 */
function highlightText(text, target) {
  if (!text || !target) {
    return text;
  }

  const sanitizedTarget = escapeRegExp(target);
  const regex = new RegExp(sanitizedTarget, 'gi');
  const joints = text.match(regex);

  // Return text as is if no match
  if (!joints) {
    return text;
  }

  const parts = text.split(regex);
  const result = [];

  while (parts.length > 0 || joints.length > 0) {
    const part = parts.shift();
    const joint = joints.shift();

    if (part) {
      result.push(part);
    }
    if (joint) {
      result.push(<b>{joint}</b>);
    }
  }

  return result;
}

export default highlightText;
